<script setup lang="ts">
defineProps({ blok: Object });
</script>

<template>
  <section class="section">
    <UiContainer max-width="max-w-6xl">
      <header class="mb-20 global-text text-center">
        <StoryblokRichText :doc="blok?.header" />
      </header>
      <div class="flex flex-wrap -m-12">
        <div class="w-5/12 p-12 max-[641px]:w-full">
          <div>
            <div
              class="min-h-full relative border-[2px] border-chsc-indigo-500 rounded-[40px] py-8 px-2 text-center"
            >
              <header
                class="absolute top-0 left-0 w-full flex items-center justify-center -translate-y-1/2"
              >
                <h5 class="text-chsc-indigo-500 fs-3xl font-londrina-solid bg-white px-4">
                  {{ blok?.suppliers_title }}
                </h5>
              </header>
              <!-- <div class="flex items-center justify-center">
                                <p class="text-chsc-yellow text-[130px] leading-[110px] font-londrina-solid">
                                    {{ blok?.suppliers_data }}
                                </p>
                                <svg
                                    width="67"
                                    height="95"
                                    viewBox="0 0 67 95"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M50.4675 95L18.2727 95L18.2727 29.4667L-2.86455e-06 29.4667L35.6753 -1.55942e-06L67 29.4667L50.4675 29.4667L50.4675 95Z"
                                        fill="#360086"
                                    />
                                </svg>
                            </div> -->
              <div>
                <p class="font-londrina-solid fs-5xl text-chsc-indigo-500">
                  {{ blok?.suppliers_description }}
                </p>
              </div>
            </div>
            <div class="mt-20">
              <img :src="blok?.certifications.filename" :alt="blok?.certifications.alt" />
            </div>
          </div>
        </div>
        <div class="w-7/12 p-12 max-[641px]:w-full">
          <div class="global-text">
            <StoryblokRichText :doc="blok?.description" />
          </div>
        </div>
      </div>
    </UiContainer>
  </section>
</template>
